<template>
  <div class="root">
    <div v-bind:class="{ container: true }" id="app" v-if="activeBrand">
      <header>
        <Header />
      </header>
      <main v-bind:class="{ main: true }">
        <div id="dynamic-element"></div>
        <template v-if="$route.matched.length">
          <router-view></router-view>
        </template>
      </main>
      <div v-if="showBottomPanel" class="bottom-panel"></div>
      <Footer v-if="!builderVisible" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import Header from "./components/header/Header";
import Footer from "./components/Footer";

export default {
  components: {
    Header,
    Footer,
  },
  computed: {
    ...mapState("app", [
      "activeBrand",
      "activeEnv",
      "builderVisible",
      "showBottomPanel",
    ]),
  },
  created() {
    if (process.env.NODE_ENV === "development" || process.env.ENV === "dev") {
      this.$store.dispatch("app/getEnvs");
    }
  },
  watch: {
    activeEnv(activeEnv) {
      axios.defaults.baseURL = activeEnv.operatorUrl;
      this.$store.dispatch("app/getBrands", activeEnv.name);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
html {
  height: 100%;
}

body {
  height: 100%;
  min-height: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  background-color: #12222b;
}

header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1060;
}

.root {
  height: 100%;
}

.container {
  position: relative;
  height: 100%;
}

.main {
  min-height: calc(100% - 120px - 128px);
  padding-top: 64px;
}

.link {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
}

.link:hover {
  color: #fff;
}

.scroll-disabled {
  overflow: hidden !important;
}

.bottom-panel {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 64px;
  background: #172329;
  z-index: 1000;
}

@media (max-width: 600px) {
  .main {
    min-height: calc(100% - 112px - 350px);
    padding-top: 56px;
  }
}
</style>
